const data = {
  title: "Floor 2-3",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 9,
  tilesHeight: 9,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 5,
      y: 5,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 8,
    },
    {
      type: "WALL",
      x: 6,
      y: 4,
    },
    {
      type: "WALL",
      x: 4,
      y: 6,
    },
    {
      type: "WALL",
      x: 4,
      y: 4,
    },
    {
      type: "WALL",
      x: 2,
      y: 2,
    },
    {
      type: "WALL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 6,
      y: 2,
    },
    {
      type: "WALL",
      x: 4,
      y: 2,
    },
    {
      type: "WALL",
      x: 2,
      y: 4,
    },
    {
      type: "WALL",
      x: 8,
      y: 4,
    },
    {
      type: "WALL",
      x: 2,
      y: 6,
    },
    {
      type: "WALL",
      x: 8,
      y: 6,
    },
    {
      type: "WALL",
      x: 2,
      y: 8,
    },
    {
      type: "WALL",
      x: 4,
      y: 8,
    },
    {
      type: "WALL",
      x: 6,
      y: 8,
    },
    {
      type: "WALL",
      x: 6,
      y: 6,
    },
    {
      type: "ENEMY_SPAWN",
      x: 7,
      y: 6,
      direction: "UP",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 3,
      y: 4,
      direction: "DOWN",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 7,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 4,
      y: 3,
      direction: "RIGHT",
      enemyType: "ENEMY",
    },
    {
      type: "CHIP",
      x: 3,
      y: 7,
    },
    {
      type: "CHIP",
      x: 3,
      y: 3,
    },
    {
      type: "CHIP",
      x: 7,
      y: 3,
    },
    {
      type: "CHIP",
      x: 7,
      y: 7,
    },
  ],
};

export default data;
